import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

// Default tag name is 'svgicon'
Vue.use(BootstrapVue)
